/* Fonzie Application 
 ========================================================================== */
 
$(function() {
	/* Global */
	template.media_query();

	/* Application */
	app.donations();

  /* Template */
	template.main_nav();
	template.main_search();
	template.share_modal();
	template.campaign_progress();
	template.repeater_gallery();
	template.accordion();
	template.panelClass();
	template.archive_filter();
	template.tables();
	template.donationProcess();
	template.donation_widget();
	template.logo_carousel();
	template.forumWYSIWYG();
	template.element_link();
	template.search();
	template.group_submit();
	template.groups_filter();
	template.group_page();
	template.tips();
	template.tips_block();
	template.anchorLinks();
	//template.flex_content_blocks();

	var map = $('.acf-map');

	if (map.length > 0) {
		map.each(function () {
			// create map
			map = app.new_map($(this));
		});
	}
});

// $(window).on("load", function () {
// 	if(window.location.hash) {  
// 		var urlHash = window.location.hash.substring(1);
// 		$('html,body').animate({
// 			scrollTop: $('#' + urlHash).offset().top - 32
// 		}, 800);
// 	}
// });

$(document).ready(function(){
	//alert('test');
	$('.toggle_saved_page').on('click', function(e){
		e.preventDefault();
    if($(this).hasClass('pending_ajax_save')){
        return false;
    }
		$(this).addClass('pending_ajax_save');
		var request = $.ajax({
			url: $(this).attr('href'),
		    method: "GET",
		  	dataType: "json"
		});
		  
		request.done(function( msg ) {
			if(msg.success){
				$('.pending_ajax_save').toggleClass('saved_page heart_play').removeClass('pending_ajax_save');	
				setTimeout(function () {
					$('.heart_play').removeClass('heart_play');	
				}, 1000);
			} else {
				var message_clone = $('#save_login_message').clone();
				message_clone.insertAfter('#save_login_message');
				let save_login_message = $('#save_login_message:first-of-type');
				if(msg.action == "register"){
					bootbox.dialog({
		              show: true,
		              closeButton: true,
					  message: save_login_message
		              //message: '<div class="save-page-login-message">You need to be logged in to save pages. <br><a href="/login">Login</a><br><a href="/register">Register</a></div>'
		          	});
				}
			}
			$('.pending_ajax_save').removeClass('pending_ajax_save');
		});
		 
		request.fail(function( jqXHR, textStatus ) {
		  	console.log( "Request failed: " + textStatus );
		  	$('.pending_ajax_save').removeClass('pending_ajax_save');
		});
	});

	if(window.location.hash) {
      var hash = window.location.hash.substring(1);

      if(hash == "saved"){
      	bootbox.dialog({
          show: true,
          closeButton: true,
          message: 'Page has been saved.'
      	});
      }
  	}


  	window.setTimeout(function(){
        $('.floating_message').fadeOut(1000);
	}, 5000); 
	
	$('#menu-useful-links a').on('click', function(e){
		if ($(this).text() == "Cookie Preferences" || $(this).attr('href') == '#cookies-open') {
			e.preventDefault();
			CookieControl.open();
		}
	});

	//Donate Form
	// if (document.cookie.indexOf('donate_form_close=') == -1) {
	// 	$('.donate-popup .form-container iframe').on('load', function () {
	// 		$(".donate-popup-container").removeClass("hidden");
	// 	});
	// }

	if (window.location.hash == '#donate') {
		if ($('body').is('.home-page')) {
			$(".donate-popup-container").removeClass("hidden");
			$(".donate-popup .form-container").removeClass("iframe-hidden");
		}
	}
	$('header #header-donate').on('click', function () {
		$(".donate-popup-container").removeClass("hidden");
		$(".donate-popup .form-container iframe").attr('src', $(".donate-popup .form-container iframe").attr('src'));
		$(".donate-popup .form-container").removeClass("iframe-hidden");

	});
	$('.donate-popup .donate-popup-close').on('click', function () {
		// var d = new Date();
		// d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
		// document.cookie = "donate_form_close=1;expires=" + d.toUTCString() + '; path=/';
		$(".donate-popup-container").addClass("hidden");
	});
	$('.donate-popup-container').on('click', function (e) {
		if (!$('.donate-popup-container .donate-popup *').is(e.target)) {
			$(".donate-popup-container").addClass("hidden");
		}
	});

	$('.cards-filters .mobile-filter-expand').on('click', function (e) {
		$(this).toggleClass('active');
		$(this).siblings('.list-filters').slideToggle();
		$('.cards-filters .mobile-filter-close').toggleClass('show');
	});
	$('.cards-filters .mobile-filter-close').on('click', function (e) {
		$(this).removeClass('show');
		$(this).siblings('.list-filters').slideUp(100);
		$('.cards-filters .mobile-filter-expand').removeClass('active');
		$('.cards-filter-list')[0].scrollIntoView();
	});

	get_notification_amount();

	$('.information_cta_link').on('click', function(e){
    var url = $(this).attr('data-url');
    if(url != $(this).attr('href')){
      document.cookie = "info_cta_url="+encodeURIComponent(url)+"; path=/; max-age=" + 3600;    
    }        
	});
	
  if($('#input_101_6').length && getCookie('info_cta_url')){
  	$('#input_101_6').val(getCookie('info_cta_url'));
  };
});

function get_notification_amount(){
    if(wp_user_id < 1){
        return;
    }

    var notifications_request = $.ajax({
        url: "https://test.gingerbread.org.uk/?theme_action=get_notification_amount&user_id="+wp_user_id,
        method: "GET",
        dataType: "jsonp"
    });
     
    notifications_request.done(function( msg ) {
        console.log(msg);
    });
     
    notifications_request.fail(function( jqXHR, textStatus ) {
        console.log( "Request failed: " + textStatus );
        console.log(JSON.stringify(jqXHR));
    });
}

 